import {AppMenu} from "../../app-menu";

export const useSections = () => {
    return AppMenu()
};